<template>
  <div class="bg-white p-3 rounded">
    <span>
      <i class="fa fa-info-circle mr-2 orange" />
      <span class="title">Historial de Estatus</span>
    </span>
    <CustomTimeLine :items="items" />
  </div>
</template>

<script>
import CustomTimeLine from 'custom-time-line';
import months from '@/utils/constants/months';

export default {
  name: 'StatusTimeline',
  components: {
    CustomTimeLine,
  },
  data: () => ({ scrollPosition: 0, items: [] }),
  props: {
    history: { type: Array, default: () => [] },
  },
  mounted() {
    this.items = this.history.map((x) => ({
      status: {
        text: x.status.text,
        color: x.status.color,
      },
      date: this.formatDate(x.date),
      text: x.requester.name + '\r\n' + x.requester.position,
    }));
  },
  methods: {
    formatDate(value) {
      const date = new Date(value).toLocaleDateString('es-ES').split('/');
      return `${date[0]}/${months[date[1] - 1]}/${date[2]}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.orange {
  color: #ff7058;
}
.title {
  font: normal normal bold 16px/19px Lato;
  letter-spacing: 0px;
  color: #3f5b60;
}
.hori-timeline {
  overflow-x: scroll;
  scroll-behavior: smooth;
}
.hori-timeline .events {
  height: 120px;
  border-top: 2px solid #e2e2e2;
}
.hori-timeline .events .event-list {
  display: inline-block;
  position: relative;
  text-align: center;
  margin-right: 0;
  min-width: 200px;
  border-top: 2px solid #e2e2e2;
  margin-top: -2px;
}
.event-date {
  font-weight: bold;
  font-size: 15px;
  color: #11291b;
  opacity: 1;
}
.hori-timeline .events .event-list:before {
  content: '';
  position: absolute;
  height: 8px;
  border: 2px solid #707070;
  top: -4px;
  border-radius: 30px;
  width: 8px;
  background: #707070;
}
.hori-timeline .events .event-list .event-name {
  width: auto;
  border-radius: 20px;
  padding: 1px 10px;
  font: normal normal bold 14px/21px Lato;
  color: #11291b;
}
.event-requester {
  font-size: 12px;
  font-weight: bold;
  color: #727272;
  opacity: 1;
}
.event-requester-position {
  font-size: 12px;
  width: 100%;
  color: #727272;
  line-height: 5px;
  float: left;
  font-weight: lighter;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hori-timeline::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.hori-timeline {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scroll-button {
  border: 1px solid #f2f2f2;
  border-radius: 5px;
  width: 30px;
  height: 154px;
  cursor: pointer;
  text-align: center;
  & i {
    color: #b5c3bc;
  }
}
</style>
